import { render } from "./ImageViewerFooter.vue?vue&type=template&id=488df076&scoped=true&ts=true"
import script from "./ImageViewerFooter.vue?vue&type=script&lang=ts"
export * from "./ImageViewerFooter.vue?vue&type=script&lang=ts"

import "./ImageViewerFooter.vue?vue&type=style&index=0&id=488df076&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-488df076"]])

export default __exports__